// FIXME: pp-react <Link /> component breaks in IE11 due to Array.from. below import should be removed once we upgrade to pp-react Link component.
import 'core-js/es/array/from'
import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from '@reach/router'
import { Provider } from 'react-redux'
import App from './App'
import { REDUCER_STATE_NAMES } from './reducers'
import { serverData, initServerData } from 'utils/server-data'
import { configureStore } from 'shared/utils/redux/configure-store'
import * as fpti from 'utils/fpti'
import { initClientErrorLogger } from 'utils/logger'
import { pick } from 'lodash-es'
import { ContextProvider as WorldReadyContextProvider } from '@paypalcorp/worldready-react'
import { ThemeProvider } from '@emotion/react'
import { PAYPAL_THEME } from '@paypalcorp/pp-react-theme'
import './shared/utils/datadog'
import { isInIframe } from './shared/utils/utils'
import XoPPDCUpsell from './screens/xo-ppdc-upsell/xo-ppdc'

initServerData()
fpti.initFPTI(serverData.fpti)

initClientErrorLogger()

const root = document.getElementById('root')
const initialStates = pick(serverData, REDUCER_STATE_NAMES)
const store = configureStore(initialStates)

if (isInIframe()) {
  ReactDOM.render(
    <Provider store={store}>
      <WorldReadyContextProvider locale={serverData.locality.locale}>
        <ThemeProvider theme={PAYPAL_THEME}>
          <XoPPDCUpsell />
        </ThemeProvider>
      </WorldReadyContextProvider>
    </Provider>,
    root,
  )
}
else {
  ReactDOM.render(
    <Provider store={store}>
      <WorldReadyContextProvider locale={serverData.locality.locale}>
        <ThemeProvider theme={PAYPAL_THEME}>
          <Router basepath={serverData.requestURI}>
            <App path="*" />
          </Router>
        </ThemeProvider>
      </WorldReadyContextProvider>
    </Provider>,
    root,
  )
}
